import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useGlobalSettingsStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        content: {
            marginLeft: 2,
            marginRight: 2,
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(3),
        },
        sectionContent: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
        },
        sectionDescription: {
            fontSize: theme.typography.pxToRem(14),
            fontWeight: 400,
            textAlign: "center",
            color: theme.palette.primary.dark,
        },
        fieldRow: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: theme.spacing(1),
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
        exposureFields: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(2),
            width: "100%",
            maxWidth: 320,
            marginTop: theme.spacing(2),
        },
        currentTextExceeded: {
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.error.main,
            fontSize: theme.typography.pxToRem(12),
        },
        legacyToggleRow: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: theme.spacing(2),
        },
        legacyFootnote: {
            fontSize: theme.typography.pxToRem(13),
            fontWeight: 400,
            textAlign: "center",
            color: theme.palette.primary.dark,
            marginTop: theme.spacing(2),
        },
        configChangeWarning: {
            color: theme.palette.warning.dark,
            fontSize: theme.typography.pxToRem(14),
            marginTop: theme.spacing(1),
            textAlign: "center",
        },
    });
};
